import type { FC } from "react"
import type { XAxisProps } from "recharts"
import { XAxis } from "recharts"

import { getDateFromTimestamp } from "common/helpers/date"
import { DATE_FORMATS } from "common/constants/date"
import type { TickProps } from "common/types/chart"

const DateXAxis: FC<XAxisProps> = ({ ...xAxisProps }) => (
  <XAxis
    axisLine={false}
    dataKey="timestamp"
    interval="preserveEnd"
    name="Date"
    padding={{ left: 0, right: 20 }}
    stroke="#9FA2B4"
    tick={<XTick dx={20} dy={30} />}
    tickLine={false}
    {...xAxisProps}
  />
)

export default DateXAxis

const XTick: FC<TickProps> = ({
  x,
  y,
  payload,
  dy = 0,
  dx = 0,
  color = "#718096",
}) => {
  const timestamp = payload?.value

  if (!timestamp) return null

  const date = getDateFromTimestamp(Number(timestamp))
  const dateLabel = date.format(DATE_FORMATS.monthOrdinalDay)

  return (
    <g transform={`translate(${x as number},${y as number})`}>
      <text
        dx={dx}
        dy={dy}
        fill={color}
        fontSize="10px"
        textAnchor="end"
        x={0}
        y={0}
      >
        {dateLabel}
      </text>
    </g>
  )
}
